<template>
  <div style="display: block; height: auto; overflow-y: auto">
      <table ref="table" class="table table-sm table-borderless table-responsive">
          <thead>
          <tr>
              <th>{{ $t('material_station.name') }}</th>
              <th>{{ $t('material_station.scale_id') }}</th>
              <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in modelValue" :key="index">
              <!-- Name field -->
              <td>
                  <input
                      v-if="editable"
                      v-model="item.name"
                      type="text"
                      class="form-control form-control-sm m-0"
                      :class="{ 'is-valid': isValidInput(item.name) }"
                  />
                  <span v-else>{{ item.name }}</span>
              </td>

              <!-- Scale ID field -->
              <td>
                  <input
                      v-if="editable"
                      v-model="item.scale_id"
                      type="text"
                      class="form-control form-control-sm m-0"
                      :class="{ 'is-valid': isValidInput(item.scale_id) }"
                  />
                  <span v-else>{{ item.scale_id }}</span>
              </td>

              <!-- Delete button -->
              <td>
                  <i
                      class="fas fa-trash"
                      style="cursor: pointer; margin-top: .5em"
                      @click="modelValue.splice(index, 1)"
                  ></i>
              </td>
          </tr>
          </tbody>
      </table>
    <div class="button-container">
      <button
        v-if="editable"
        class="btn btn-sm btn-primary form-button"
        @click.stop="modelValue.push(newScale())"
      >
        <span>{{ $t('material_station.add_scale') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";

export default {
    name: "MaterialList",
    mixins: [restApi],
    props: {
        modelValue: {
            type: Array,
            default() {
                return [];
            }
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        fields() {
            return [
                {
                    key: 'name',
                    label: this.$t('material_station.name'),
                    sortable: false
                },
                {
                    key: 'scale_id',
                    label: this.$t('material_station.scale_id'),
                    sortable: false
                },
                !this.editable ? undefined : {
                    key: 'edit',
                    label: ''
                }
            ]
        }
    },
    methods: {
        isValidInput(input) {
            return input !== null && input.length > 0
        },
        newScale: function () {
            return {
                name: null,
                scale_id: null
            }
        }
    }
}
</script>


<style scoped lang="scss">

</style>
